// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { infoSlideStyles } from "@conklin/App/Widgets/InfoSlide/InfoSlide";
import { color, ellipsis, hideElementOnPrint, linkArrowStyle, xScreen } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

infoSlideStyles.container = {
    css: css`
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        height: 100%;
        ${hideElementOnPrint};
    `,
};

infoSlideStyles.imageWrapper = {
    css: css`
        position: relative;
    `,
};
infoSlideStyles.imageClickable = {
    css: css`
        display: block;
        position: relative;
    `,
};

infoSlideStyles.image = {
    width: "100%",
    height: "auto",
    css: css`
        width: 100%;
        height: auto;
        border-radius: 4px 4px 0 0;
        object-fit: cover;
    `,
};

infoSlideStyles.titleTypography = {
    variant: "h4",
    as: "p",
    color: "common.white",
    css: css`
        padding: 12px 16px;
        margin-bottom: 0;
        background-color: ${color("common.black")};
        box-shadow: 0 -2px 0 0 ${color("common.white")};
        width: 100%;
        &:not(:only-child) {
            position: absolute;
            bottom: 0;
            background-color: ${color("common.black", 0.75)};
        }
        ${xScreen("lte", "lg")} {
            &&& {
                padding: 8px 12px;
                background-color: ${color("common.black")};
                position: static;
                font-size: 18px;
                line-height: 22px;
            }
        }
    `,
};

infoSlideStyles.infoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
        flex: 1;
        ${xScreen("lte", "lg")} {
            padding: 12px;
            gap: 12px;
        }
    `,
};

infoSlideStyles.descriptionTypography = {
    css: css`
        flex-grow: 1;
        ${TypographyStyle} {
            margin-bottom: 0;
            font-size: 14px;
            line-height: 22px;
            padding: 0;
            color: ${color("text.main")};
        }
        ${({ maxNumberOfDescriptionLines }: any) =>
            css`
                ${ellipsis(maxNumberOfDescriptionLines)};
            `}
    `,
};

infoSlideStyles.link = linkArrowStyle("large", {
    css: css`
        margin-top: auto;
    `,
});

infoSlideStyles.smallLink = linkArrowStyle("small", {
    css: css`
        margin-top: auto;
    `,
});
